// extracted by mini-css-extract-plugin
module.exports = {"about-page":"about-page--3UWIX","about-page__foreign":"about-page__foreign--1_WvH"};